<div class="account-container">
  <h2 id="modal-title">Account Management</h2>

  <mat-tab-group animationDuration="0ms" class="account-tabs" [(selectedIndex)]="selectedTabIndex">

    <!-- TAB 1: PROFILE & SECURITY -->
    <mat-tab label="Profile & Security">
      <div class="tab-content">

        <!-- Card 1: Change Email / Login -->
        <div class="account-card">
          <div class="card-header">
            <h4>Email Address & Login</h4>
            <span class="card-subtitle">Manage the email address associated with your account</span>
          </div>

          <form [formGroup]="accountForm" class="card-body">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Email Address</mat-label>
              <input matInput formControlName="email" name="email" required [(ngModel)]="form.email">
              <mat-error *ngIf="email?.errors?.required">Email is required.</mat-error>
              <mat-error *ngIf="email?.errors?.pattern">Please provide a valid email address.</mat-error>
            </mat-form-field>

            <div class="card-actions">
              <button mat-raised-button color="primary" type="button" (click)="saveEmail()"
                [disabled]="accountForm.get('email')?.invalid || accountForm.get('email')?.pristine">
                Save Email
              </button>
            </div>
          </form>
        </div>

        <!-- Card 2: Change Password -->
        <div class="account-card">
          <div class="card-header">
            <h4>Change Password</h4>
            <span class="card-subtitle">Ensure your account is using a long, random password to stay secure</span>
          </div>

          <form [formGroup]="passwordForm" class="card-body">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Current Password</mat-label>
              <input matInput [type]="hide_current ? 'password' : 'text'" formControlName="currentpassword">
              <button mat-icon-button matSuffix (click)="hide_current = !hide_current" type="button">
                <mat-icon>{{hide_current ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-error *ngIf="currentpassword?.errors?.required">Current password is required.</mat-error>
            </mat-form-field>

            <div class="row">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>New Password</mat-label>
                <input matInput [type]="hide_new ? 'password' : 'text'" formControlName="newpassword">
                <button mat-icon-button matSuffix (click)="hide_new = !hide_new" type="button">
                  <mat-icon>{{hide_new ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <mat-error *ngIf="newpassword?.errors?.minlength">Minimum 6 characters required.</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Confirm New Password</mat-label>
                <input matInput [type]="hide_confirm ? 'password' : 'text'" formControlName="confirmpassword">
                <button mat-icon-button matSuffix (click)="hide_confirm = !hide_confirm" type="button">
                  <mat-icon>{{hide_confirm ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <mat-error *ngIf="confirmpassword?.errors?.confirmedValidator">Passwords must match.</mat-error>
              </mat-form-field>
            </div>

            <div class="error-message" *ngIf="changeFailed">{{errorMessage}}</div>

            <div class="card-actions">
              <button mat-raised-button color="primary" type="button" (click)="savePassword()"
                [disabled]="passwordForm.invalid">
                Update Password
              </button>
            </div>
          </form>
        </div>

      </div>
    </mat-tab>

    <!-- TAB 2: SUBSCRIPTION & PLAN -->
    <mat-tab label="Subscription">
      <div class="tab-content">

        <div class="account-card">
          <div class="card-header flex-header">
            <div>
              <h4>Current Plan</h4>
              <span class="card-subtitle">Manage your subscription and billing details</span>
            </div>
            <span class="badge-active">{{ userSubscription?.subscriptionName || 'Trial' }}</span>
          </div>

          <div class="card-body">
            <div class="stats-grid">
              <div class="stat-box">
                <span class="stat-label">Plan Status</span>
                <span *ngIf="isSubscriptionActive" class="stat-value text-success">Active</span>
                <span *ngIf="!isSubscriptionActive" class="stat-value text-nosuccess">Not active</span>
              </div>
              <div class="stat-box">
                <span class="stat-label">Auto-Renew</span>
                <span *ngIf="userSubscription?.autoRenew" class="stat-value text-success">
                  <mat-icon inline>sync</mat-icon> Enabled
                </span>
                <span *ngIf="!userSubscription?.autoRenew && isSubscriptionActive" class="stat-value text-warning">
                  <mat-icon inline>sync_disabled</mat-icon> Cancels at end
                </span>
                <span *ngIf="!isSubscriptionActive" class="stat-value text-nosuccess">Disabled</span>
              </div>
              <div class="stat-box">
                <span class="stat-label">Subscription till</span>
                <span class="stat-value">{{ userSubscription?.endDate | date:'mediumDate' }}</span>
              </div>
            </div>

            <div *ngIf="isSubscriptionActive && !userSubscription?.autoRenew" class="cancellation-alert">
              <mat-icon color="warn">info</mat-icon>
              <span *ngIf="userSubscription?.endDate != null">Your subscription is canceled and will not auto-renew. You retain full access until <strong>{{
                  userSubscription?.endDate | date:'mediumDate' }}</strong>.</span>
              <span *ngIf="userSubscription?.endDate === null">Your subscription is canceled and will not auto-renew.</span>
            </div>

            <mat-divider></mat-divider>

            <div class="subscription-info">
              <h5>Included Features</h5>
              <ul class="feature-checklist">
                <li><mat-icon color="primary">check_circle</mat-icon> Unlimited Notes & Tasks</li>
                <li><mat-icon color="primary">check_circle</mat-icon> Calendar Integration</li>
                <li><mat-icon color="primary">check_circle</mat-icon> Checklists</li>
                <li><mat-icon color="primary">check_circle</mat-icon> App</li>
              </ul>
            </div>
          </div>

          <div class="card-actions">
            <button *ngIf="!isSubscriptionActive" mat-stroked-button color="primary" (click)="buySubscription()">
              <mat-icon>credit_card</mat-icon>Buy</button>
            <button *ngIf="isSubscriptionActive" mat-stroked-button color="primary" (click)="openStripePortal()">
              <mat-icon>receipt_long</mat-icon>
              Manage subscription
            </button>
          </div>
        </div>

      </div>
    </mat-tab>

  </mat-tab-group>
</div>